<template>
  <div>
    <error-alert
      v-if="error"
      :error="error"
    />
    <validation-observer
      ref="form"
    >
      <div>
        <poster-ai-generate-trigger @generated="onAiPostGenerated">
          <template #title>
            <h4 class="font-weight-bold mb-0">
              {{ getPosterTrans("message") }}
            </h4>
          </template>
        </poster-ai-generate-trigger>
        <div class="text-with-emoji">
          <validation-provider
            #default="{ errors }"
            :name="getPosterTrans('message')"
            :rules="isImagePost?'':'required'"
          >
            <textarea
              ref="message"
              v-model="form.message"
              name="message"
              :style="messageStyle"
              rows="5"
              cols="50"
              class="form-control emoji autoresize"
              :placeholder="getPosterTrans('status_placeholder')"
              @click="showEmoji=false"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <picker
            v-show="showEmoji"
            color="#367fa9"
            :show-preview="false"
            :data="index1"
            @select="addEmoji"
          />
          <a
            ref="emoji"
            href="#"
            @click.prevent="showEmoji=!showEmoji"
          ><FeatherIcon
            size="20"
            icon="SmileIcon"
          /></a>

        </div>
        <p
          v-if="form.message.length>130 && form.fb_preset_id!==0"
          class="text-red small"
        >
          {{ getPosterTrans("preset_hint") }}
        </p>
      </div>
      <hr>
      <h4 class="mb-1">
        {{ getPosterTrans("image_title") }}
      </h4>
      <my-menu-media-input
        ref="media"
        v-model="form.files"
        :max-files="50"
        disable-video
      />
      <hr>
      <div>
        <h4 class="mb-2 font-weight-bold">
          {{ getPosterTrans("reply-title") }}
        </h4>
        <b-form-checkbox
          v-model="addReply"
          checked="false"
          name="check-button"
          switch
          inline
        >
          {{ getPosterTrans('choose_reply_title') }}
        </b-form-checkbox>
        <div
          v-if="addReply && templates.length"
          class="demo-inline-spacing mb-2 mx-lg-3 mx-1"
        >
          <div class="d-flex flex-column">
            <b-form-radio
              v-model="fromExist"
              name="add-reply"
              :value="false"
              class="mr-3 custom-control-primary"
            >
              {{ getPosterTrans('add-new-reply') }}
            </b-form-radio>
            <div class="mt-md-1" />
          </div>
          <div class="d-flex flex-column">
            <b-form-radio
              v-model="fromExist"
              name="add-reply"
              :value="true"
              class="custom-control-primary"
            >
              {{ getPosterTrans('add-exist-reply') }}

            </b-form-radio>
            <small class="form-text text-muted ml-2">
              {{ getPosterTrans('add-exist-reply-hint') }}
            </small>
          </div>
        </div>
        <template v-if="addReply">
          <div class="mx-lg-3 mx-1">
            <validation-provider
              v-if="fromExist"
              #default="{ errors }"
              :name="$t('reply.template_name')"
              rules="required"
            >
              <templates-select

                v-model="form.template_id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <ok-text-input
              v-if="showReplyMessageField"
              v-model="form.reply_message"
              textarea
              is-required
              class="mt-2"
              :placeholder="getPosterTrans('reply-message-hint')"
              :label="getPosterTrans('reply-message-title')"
            />
          </div>
        </template>
      </div>
      <hr>
      <div>
        <h4 class="font-weight-bold">
          {{ getPosterTrans("schedule_time_title") }}
        </h4>
        <div class="demo-inline-spacing mb-2">
          <b-form-radio
            v-model="form.schedule_type"
            name="schedule_type"
            value="now"
            class="mr-3 custom-control-primary"
          >
            {{ getPosterTrans('publish_post') }}
          </b-form-radio>
          <b-form-radio
            v-model="form.schedule_type"
            name="schedule_type"
            value="later"
            class="custom-control-primary"
          >
            {{ getPosterTrans('schedule_post') }}
          </b-form-radio>
        </div>
        <template v-if="form.schedule_type==='later'">
          <div
            style="position:relative;"
          >
            <poster-schedule
              ref="schedule"
            />
          </div>
        </template>
        <hr>
      </div>
    </validation-observer>
    <div class="form-group">
      <b-button
        variant="success"
        class="btn-block"
        :disabled="loading"
        @click="submit"
      >
        <b-spinner
          v-if="loading"
          size="small"
          class="mr-1"
        /> {{ getPosterTrans('submit') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/facebook.json'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { mapGetters } from 'vuex'
import {
  BButton, BFormRadio, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { forEach } from 'lodash'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import TemplatesSelect from '@/@bya3/components/inputs/TemplatesSelect'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import PosterSchedule from '@/views/owner-fb/poster/components/PosterSchedule'
import PosterAiGenerateTrigger from '@/@bya3/components/poster/PosterAiGenerateTrigger.vue'
import MyMenuMediaInput from '@/views/media/MyMenuMediaInput'
import FbPosterApi from '@/api/poster'

const index1 = new EmojiIndex(data)

export default {
  name: 'PosterForm',
  components: {
    MyMenuMediaInput,
    ErrorAlert,
    TemplatesSelect,
    OkTextInput,
    PosterSchedule,
    PosterAiGenerateTrigger,
    Picker,
    BButton,
    BFormRadio,
    BFormCheckbox,
    ValidationObserver,
    ValidationProvider,
    BSpinner,
  },
  data() {
    return {
      showEmoji: false,
      index1,
      messageHeight: '200',
      addReply: false,
      fromExist: false,
      template: {},
      loading: false,
      error: null,
    }
  },
  computed: {
    ...mapGetters({
      form: 'poster/form',
      images: 'poster/images',
      templates: 'reply/templates',
      currentPage: 'pages/currentPage',
    }),
    messageStyle() {
      return {
        'min-height': this.messageHeight,
      }
    },
    showReplyMessageField() {
      return !this.fromExist || (this.fromExist && ['text', 'buttons'].includes(this.template.message_type ?? 'no'))
    },
    isImagePost() {
      return this.form?.files.length > 1
    },
    isEdit() {
      return !!this.$route.params.id
    },
  },
  watch: {
    'form.message': function () {
      this.resize()
    },
    'form.template_id': function (val) {
      if (val) {
        this.setTemplate()
      }
    },
    fromExist() {
      this.setTemplate()
    },
  },
  async mounted() {
    this.setIfEdit()
    await this.$store.dispatch('reply/GET_TEMPLATES')
    if (this.templates?.length) this.form.template_id = this.templates[0].id
  },
  methods: {
    setIfEdit() {
      if (this.form.template_id || this.form.reply_message) this.addReply = true
      if (this.form.template_id) this.fromExist = true
    },
    setTemplate() {
      this.template = this.templates?.find(t => t.id === this.form.template_id)
      if (this.fromExist) {
        this.form.reply_message = this.template.message_type === 'text'
          ? (this.template?.reply_message?.text ?? '') : (this.template?.reply_message?.attachment?.payload?.text ?? '')
      }
    },
    openDialog(index) {
      this.$refs.image[index].click()
    },
    resize() {
      this.messageHeight = `${this.$refs.message.scrollHeight}px`
    },
    getPosterTrans(str) {
      return this.$t(`poster.${str}`)
    },
    onAiPostGenerated(text) {
      this.$store.commit('poster/SET_FORM', { message: text })
      this.$nextTick(() => this.resize())
    },
    addEmoji(emoji) {
      const ele = this.$refs.message
      const startPos = ele.selectionStart
      const endPos = ele.selectionEnd
      const tmpStr = ele.value
      this.form.message = tmpStr.substring(0, startPos) + emoji.native + tmpStr.substring(endPos, tmpStr.length)
    },
    upload(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      forEach(files, file => {
        if (this.images.length < 10) {
          const url = URL.createObjectURL(file)
          this.images.push({
            url, file, watermark: false, temp: url,
          })
        }
      })
    },
    removeImage(index) {
      this.images.splice(index, 1)
    },
    async submit() {
      this.error = null
      if (this.$refs.schedule?.$refs?.form && !await this.$refs.schedule.$refs.form.validate()) {
        this.error = this.$tc('errors.field-invalid', 2)
        return
      }
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const formData = { ...this.form }

        formData.page_id = this.currentPage.id
        if (!this.addReply || this.fromExist) formData.reply_message = ''
        if (!this.fromExist || !this.addReply) formData.template_id = null
        if (this.isImagePost) formData.type = 'image'
        if (this.form?.schedule_type === 'now') delete formData.schedule_time
        FbPosterApi.addPost(formData, this.$route?.params?.id).then(res => {
          this.$notifySuccess(res.message)
          const type = this.form?.schedule_type
          this.$store.commit('poster/SET_FORM',
            {
              message: '',
              fb_preset_id: 0,
              pages: [],
              reply_message: '',
              schedule_type: 'now',
              schedule_time: [''],
              template_id: '',
              type: 'message',
              files: [],
            })
          this.$router.push({ name: type === 'later' ? 'owner:scheduled-posts' : 'owner:published-posts' })
        }).catch(e => { this.error = e }).finally(() => { this.loading = false })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.input-group{
  margin: 0;
}
</style>
